import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/common/base/base.service';
import { FormStatusEnum, FormType } from 'src/app/common/enumerations/enumerations';
import { IFormHistoryService } from './i-form-history-service';
import { FormHistoryScfService } from '../form-history-forms/form-history-scf/form-history-scf.service';
import { FormViewState } from 'src/app/common/models/form-view-state';
import { FormHistoryRsswaService } from '../form-history-forms/form-history-rsswa/form-history-rsswa.service';
import { FormHistoryEbService } from '../form-history-forms/form-history-eb/form-history-eb.service';
import { FormHistoryRsfService } from '../form-history-forms/form-history-rsf/form-history-rsf.service';

@Injectable({
  providedIn: 'root'
})
export class FormHistoryService extends BaseService<any, number> implements IFormHistoryService {

  constructor(
    protected override injector: Injector,
    private fhSCFService: FormHistoryScfService,
    private fhRSSWAService: FormHistoryRsswaService,
    private fhEBService: FormHistoryEbService,
    private fhRSFService: FormHistoryRsfService
  ) {
    super(injector, '');
  }

  /**
   * Routes serialized form history through the document-specific history adapter.
   * @param form Original serialized form body.
   * @param logForm Workflow and amendment history returned by the API.
   * @param finalForm Current form used by adapters that need live workflow context.
   * @returns Processed history data, or null when the form type has no adapter.
   */
  async processForm(form: any, logForm: LogForm, finalForm: any): Promise<LogForm | null> {
    switch (form.type) {
      case FormType.SCF:
        return await this.fhSCFService.processForm(form, logForm, finalForm);

      case FormType.RSSWA:
        return await this.fhRSSWAService.processForm(form, logForm, finalForm);

      case FormType.EBF:
        return await this.fhEBService.processForm(form, logForm);

      case FormType.PPSTB:
        // PPSTB uses the same serialized Form/FormVersion amendment structure as EB history.
        return await this.fhEBService.processForm(form, logForm);

      case FormType.RSF:
        return await this.fhRSFService.processForm(form, logForm, finalForm);

      default:
        return null;
    }
  }

}

export interface LogSignature {
  name?: string;
  signedBy?: string;
  signedOn?: Date;
  amendmentId?: number;
  reason?: string;
  roleName?: string;
  formStatus?: FormStatusEnum;
  //
  nameClass?: string;
  status?: string;
  statusClass?: string;
  showStatus?: boolean;
  isMinorAmendment?: boolean;
}

export interface LogForm // LogToShowResource in Backend
{
  type?: FormType;
  updates?: LogUpdate[];
  originalBodyJson?: string;
  signatures?: LogSignature[];
  originalBody?: any;
}

export interface LogUpdate // UpdateLogToShowResource in Backend
{
  currentBodyJson?: string;
  currentBody?: any;
  prevBodyJson?: string;
  prevBody?: any;
  amendmentId?: number;
  amendmentDate?: Date;
  status?: FormViewState;
  signatures?: LogSignature[];
  header?: string;
  footer?: string;
  isMinorAmendment?: boolean;
}
